import React from 'react'
import { money } from '../financial/formatting'
import { count, pct } from './model'

// The four headline numbers. Leads sold leads; the two shares keep the same
// colours everywhere on the page (--share-ours / --share-partner).
export default function KpiTiles({ kpis, buyerFiltered }) {
  return (
    <section aria-label="Key figures" style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
      <div className="sl-kpis">
        <div className="card" style={{ padding: 18, background: 'var(--kpi-hero-bg)', borderColor: 'var(--kpi-hero-bg)' }}>
          <TileLabel color="var(--kpi-hero-muted)">{buyerFiltered ? 'Leads sold to selected buyer' : 'Leads sold'}</TileLabel>
          <div style={{ fontSize: 30, fontWeight: 700, color: 'var(--kpi-hero-fg)', lineHeight: 1.15 }}>{count(kpis.sold)}</div>
          <div style={{ fontSize: 12, color: 'var(--kpi-hero-muted)', marginTop: 4 }}>
            {pct(kpis.soldPct)} of {count(kpis.received)} leads
          </div>
        </div>
        <Tile label="Total revenue" value={money(kpis.revenue)} caption={kpis.sold > 0 ? `${money(kpis.avgPerSale)} per sold lead` : 'No sales yet'} />
        <Tile label="Our share" value={money(kpis.ourShare)} swatch="var(--share-ours)" />
        <Tile label="Partners share" value={money(kpis.partnerShare)} swatch="var(--share-partner)" />
      </div>
      {kpis.unpricedSold > 0 && (
        <p style={{ margin: 0, fontSize: 12, color: 'var(--text-muted)' }}>
          {count(kpis.unpricedSold)} {kpis.unpricedSold === 1 ? 'sale' : 'sales'} without a frozen payout
        </p>
      )}
    </section>
  )
}

function Tile({ label, value, caption, swatch }) {
  return (
    <div className="card" style={{ padding: 18 }}>
      <TileLabel swatch={swatch}>{label}</TileLabel>
      <div style={{ fontSize: 26, fontWeight: 700, color: 'var(--text-primary)', lineHeight: 1.15 }}>{value}</div>
      {caption && <div style={{ fontSize: 12, color: 'var(--text-muted)', marginTop: 4 }}>{caption}</div>}
    </div>
  )
}

function TileLabel({ children, swatch, color = 'var(--text-muted)' }) {
  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: 6, fontSize: 11, fontWeight: 600, textTransform: 'uppercase', letterSpacing: '.05em', color, marginBottom: 6 }}>
      {swatch && <span aria-hidden="true" style={{ width: 10, height: 10, borderRadius: 3, background: swatch }} />}
      {children}
    </div>
  )
}
